import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLocation, Link, useSearchParams } from 'react-router-dom';
import './Home.css';
import { useDispatch, useSelector } from 'react-redux';
import JoinWaitlist from '../components/JoinWaitlist';
import { bindActionCreators } from 'redux';
import { actionCreator } from '../redux';
import ToastMessage from '../snippets/ToastMessage';
import { Helmet } from 'react-helmet';

const Home = () => {
  useEffect(() => {
    document.title = 'Rairer - Track & Manage Poultry Production';
  }, []);

  const [emailPopupOpen, setEmailPopupOpen] = useState(false);
  const location = useLocation();
  const account = useSelector(state => state.account);
  const dispatch = useDispatch();

  const { verifyUser } = bindActionCreators(actionCreator, dispatch);

  const [isJoinWaitlistModalOpen, setIsJoinWaitlistModalOpen] = useState(false);
  const openJoinWaitlistModal = () => {
    setIsJoinWaitlistModalOpen(true);
  };

  const closeJoinWaitlistModal = () => {
    setIsJoinWaitlistModalOpen(false);
  };

  const [msgAlert, setMsgAlert] = useState({
    active: false,
    message: "",
    status: "warning"
  });
  const [searchParam, setSearchParam] = useSearchParams();
  const [checkedVerified, setCheckedVerified] = useState(false);

  useEffect(() => {
    if (checkedVerified) return;
    const verification_code = searchParam.get('code');

    const call_verification = async () => {
      let result = await verifyUser({ code: verification_code });

      if (result.status) {
        setMsgAlert({
          active: true,
          message: "Email verified successfully.",
          status: "success"
        });
      } else {
        setMsgAlert({
          active: true,
          message: result.message,
          status: "error"
        });
      }
      searchParam.delete('code');
      setSearchParam(searchParam.toString(), { replace: true });
    };

    if (verification_code) {
      setCheckedVerified(true);
      call_verification();
    }

  }, [searchParam, checkedVerified, setSearchParam, verifyUser]);

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }

  }, [location]);

  useEffect(() => {
    if (!account || !account.isAuthenticated) return;

    setEmailPopupOpen(!account.isEmailVerified)
  }, [account]);

  return (
    <>
      <Helmet>
        <title>Rairer | Track & Manage Poultry Production</title>
        <meta name="description" content="A simpler way to plan & estimate your poultry needs. Calculate space, feed and forecast egg production with real-time personalised data." />
        <meta property="og:title" content="Rairer - Track & Manage Poultry Production" />
        <meta property="og:description" content="A simpler way to plan & estimate your poultry needs. Calculate space, feed and forecast egg production with real-time personalised data." />
        <meta property="og:image" content="https://www.rairer.com/1200x630Lightbox.png" />
        <meta property="og:url" content="https://www.rairer.com" />
      </Helmet>
      
      <div className="home-container">
        <Navbar />

        {!account.isEmailVerified && emailPopupOpen && (
          <div className='email-popup-container'>
            <div className='check-email-popup'>
              <div className='email-popup-header'>
                <img src="/assets/carbon_email.svg" alt="Email Icon" className='email-popup-icon' />
                <p className='email-popup-text'>Check your email to verify your account</p>
              </div>
              <img className='email-close-popup' src="/assets/close_filled.svg" alt="Close Icon" onClick={() => setEmailPopupOpen(false)} />
            </div>
          </div>
        )}

        <div className="hero">
          <h1 className="home-title">
            <span className="highlight">Livestock</span> farming
          </h1>
          <h1 className="home-title">
            on the go!
          </h1>
          <div>
            <h1 className="home-title-mobile">
              <span className="highlight">Livestock</span>
            </h1>
            <h1 className="home-title-mobile">
              farming on the go!
            </h1>
          </div>
          <div className='animal-field-mobile'>
            <div className='animals-container'>
              <img src="/assets/hen.svg" alt='hen' />
              <img src="/assets/cow.svg" alt='cow' />
            </div>
            <div className='subtitle-mobile-container'>
              <p className="subtitle-mobile">Simpler way to manage your livestock & farm</p>
            </div>
          </div>
          <p className="subtitle">Simpler way to manage your livestock & farm</p>
        </div>

        <div className='animal-field'>
          <img src="/assets/hen_desktop.svg" alt="hen" className='hen-desktop' />
          <img src="/assets/cow_desktop.svg" alt="cow" className='cow-desktop' />
        </div>

        <div className='farm-tools-container'>
          <div className='farm-tools'>
            <Link to='/farmcalculator' className='farm-tools-card farm-calculator-card'>
              <div>
                <h4 className='farm-tools-title calc-title'>Farm Calculator</h4>
                <div className='title-btn farm-tools-btn'>
                  <p>Production Planning Tool</p>
                </div>
                <p className='farm-tools-desc calc-desc'>Estimate key production factors like space, feed & yields for your livestock farming.  <strong>It’s FREE!</strong></p>
              </div>

              <div className='calculator-bottom-card'>
                <div className='farm-calculator-container'>
                  <div className='farm-calculator-btn'>
                    Farm Calculator
                  </div>
                  <img src='/assets/down_fill.svg' alt='down-fill' />
                </div>
                <div className='farm-calculator-holder-img'>
                  <div>
                    <img src={require('../assets/img/preview.png')} alt="preview" />
                  </div>
                </div>
                {/* <img className='calc-image' src='/assets/feed-calculator-img.svg' alt='feed' />
                <img className='calc-image-hover' src='/assets/feed-calculator-img-hover.svg' alt='feed' /> */}
              </div>

            </Link>

            <div className='farm-tools-card inventory-card'>
              <div>
                <h4 className='farm-tools-title inve-title'>Inventory & Tracking</h4>
                <div className='title-btn inventory-btn'>
                  <p>Management Tool</p>
                </div>
                <p className='farm-tools-desc'>Record, track & manage livestock production on your farm with personalised data-driven insights & analysis.</p>
              </div>

              <div className='inventory-calculator-bottom-card'>
                <img src='/assets/poultry-aminals.svg' alt='animal' />
              </div>

              <div className='inventory-notify-container-overlay'>
                <div className='inventory-notify-container'>
                  <p>This feature will be launching soon! Be the first to know and get access to exclusive offers.</p>
                  <button className='notify-btn' onClick={openJoinWaitlistModal}>Notify me</button>
                </div>
              </div>
            </div>

          </div>
        </div>

        <section id="about" className="about">
          <div className="about-container">
            <div className="about-title-container">
              <h2 className="about-title">About Rairer</h2>
              <p className="about-subtitle">
                Rairer is a cloud-based toolbox for livestock farmers. With our tools,
                farmers can plan, manage and track livestock production with real-time personalised
                data. We are currently upscaling to a robust platform to also help
                farmers maximise yield and minimise production
                cost by optimising their daily production activity
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </div>

      {msgAlert.active && <ToastMessage toastTitle={"Email Verification"} toastMessage={msgAlert.message} toastType={msgAlert.status} closeOut={() => setMsgAlert({ ...msgAlert, active: false })} />}

      {isJoinWaitlistModalOpen && (
        <JoinWaitlist closeJoinWaitlistModal={closeJoinWaitlistModal} />
      )}
      {/* <EmailVerifiedModal/> */}
    </>
  );
};

export default Home;